import React from 'react';
import {get} from 'lodash';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

/**
 * Zeigt den Inhalt eines templateContainer an entsprechend der aktuell gewählten Sprache.
 *
 * Über das "as" kann das Element angegeben werden in das der Inhalt gerendert werden soll,
 * bspw. wird <I18nTemplateContent as="span"/> gerendert als <span>...</span>, per default
 * wird ein <div> gerendert.
 *
 * Alle anderen props wie bspw. className, etc. werden zum gerenderten Element durchgeschleift.
 */
const I18nTemplateContent = ({as: Component = 'div', templateName, templateContainer, ...otherProps}) => {
    const intl = useIntl();

    const __html = get(templateContainer, [templateName, 'templateString', intl.locale]);
    return __html ? <Component dangerouslySetInnerHTML={{__html}} {...otherProps}/> : null;
};

I18nTemplateContent.propTypes = {
    as: PropTypes.any,
    templateName: PropTypes.string.isRequired,
    templateContainer: PropTypes.object.isRequired
};

export default I18nTemplateContent;
